import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { PutterSightLineForSaveDto } from '../../api/models';

export type TABLE_TYPE = Table<PutterSightLineForSaveDto>;

export const TABLE = 'putterSightline';
const SCHEMA = 'putterSightlineId, sortId';

class PutterSightlineDatabase implements DataRepository<PutterSightLineForSaveDto> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  get(key: Key): Promise<PutterSightLineForSaveDto | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: PutterSightLineForSaveDto, key: Key): Promise<PutterSightLineForSaveDto> {
    return this.db[TABLE].put(payload, key);
  }

  async bulkAdd(payload: PutterSightLineForSaveDto[]): Promise<PutterSightLineForSaveDto[]> {
    await this.db[TABLE].clear();
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<PutterSightLineForSaveDto[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const PutterSightlineDB = new PutterSightlineDatabase(db);
